import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Badge,
} from 'reactstrap';
import { axiosApi } from '../../redux/actions/index';
import { API_URL } from '../../redux/actions/types';
import Loading from '../../components/Loading/Loading';

const SecurityTab = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosApi
      .get(`${API_URL}/api/v1/config`)
      .then(({ data }) => {
        setConfig(data.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <h5 className="mb-3">Configuración de Seguridad</h5>
      <Row>
        <Col md="6">
          <Card className="mb-3">
            <CardBody>
              <h6>Tokens de Autenticación</h6>
              <p className="mb-1">
                <strong>Expiración:</strong>{' '}
                {config?.tokenExpirationHours || 24} horas
              </p>
              <p className="mb-0">
                <strong>Tokens activos:</strong>{' '}
                <Badge color="info">{config?.activeTokensCount || 0}</Badge>
              </p>
            </CardBody>
          </Card>
        </Col>
        <Col md="6">
          <Card className="mb-3">
            <CardBody>
              <h6>Política de Contraseñas</h6>
              <p className="mb-1">
                <strong>Largo mínimo:</strong>{' '}
                {config?.passwordPolicy?.minLength || 8} caracteres
              </p>
              <p className="mb-1">
                <strong>Requiere mayúscula:</strong>{' '}
                <Badge color={config?.passwordPolicy?.requireUppercase ? 'success' : 'secondary'}>
                  {config?.passwordPolicy?.requireUppercase ? 'Sí' : 'No'}
                </Badge>
              </p>
              <p className="mb-0">
                <strong>Requiere número:</strong>{' '}
                <Badge color={config?.passwordPolicy?.requireNumber ? 'success' : 'secondary'}>
                  {config?.passwordPolicy?.requireNumber ? 'Sí' : 'No'}
                </Badge>
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <Card className="mb-3">
            <CardBody>
              <h6>Resumen del Sistema</h6>
              <p className="mb-0">
                <strong>Usuarios registrados:</strong>{' '}
                <Badge color="primary">{config?.usersCount || 0}</Badge>
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SecurityTab;
